













import { defineComponent } from "@vue/composition-api";
import { ContentPriceSubjectTypeEnum } from "@scrile/api-provider/dist/api/ContentPriceProvider";
import { PaymentPackage, PaymentPackageEnum } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import providers from "@/lib/api";
import PurchaseConfirmationView from "./PurchaseConfirmationView.vue";

export default defineComponent({
  name: "PurchaseConfirmation",
  components: { PurchaseConfirmationView },
  props: {
    value: { type: Boolean, required: true },
    packageId: { type: String, required: true },
    subjectId: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      paymentPackages: [] as PaymentPackage[],
      paymentSystemsPublic: [] as PaymentSystemPublic[],
    };
  },
  watch: {
    async value(currentValue: boolean) {
      if (!currentValue) {
        return;
      }
      try {
        this.loading = true;
        const promises: Promise<any>[] = [
          providers.PaymentSystemsProvider.findAllPublic({
            data: {
              subject: { subjectId: this.subjectId, subjectType: ContentPriceSubjectTypeEnum.MESSAGE_ATTACHMENT },
            },
          }).then(r => (this.paymentSystemsPublic = r)),
        ];
        if (this.paymentPackages.length === 0) {
          promises.push(
            providers.PaymentPackageProvider.findAll({
              type: [PaymentPackageEnum.MESSAGE_ATTACHMENT],
            }).then(r => (this.paymentPackages = r))
          );
        }
        await Promise.all(promises);
      } finally {
        this.loading = false;
      }
    },
  },
});
